<template>
  <div>
    <h3>{{ $t("profile.edit.yourDocuments") }}</h3>
    <p>{{ $t("profile.kyc.regularKycInfo") }}</p>
    <kyc-status v-if="kycDocument.Id" :kycDocument="kycDocument"/>
    <button v-if="!documentsSubmitted"
      type="button"
      @click="open"
      class="btn btn-default btn-lg button-wide-crowd mb-0 uppercase">
      <span>{{ $t("profile.edit.addDocuments") }}</span>
    </button>
    <button v-if="kycDocument.Id"
      type="button"
      @click="checkDocumentsStatus"
      :disabled="processing"
      class="btn btn-default btn-lg button-wide-crowd mb-0 uppercase">
      <span v-if="!processing">{{ $t("profile.edit.checkStatus") }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
    </button>
    <button v-if="kycDocument.Status === 'CREATED'"
      type="button"
      @click="submitDocuments"
      :disabled="processing"
      class="btn btn-default btn-lg button-wide-crowd mb-0 uppercase">
      <span v-if="!processing">{{ $t("profile.kyc.submitForVerification") }}</span>
      <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
    </button>

    <!-- User KYC Modal -->
    <transition v-if="modalOpen" name="modal">
      <form @submit.prevent="sendDocuments()">
        <modal :close="close" class="modal-wide">
          <h3 slot="header">{{ $t("profile.edit.addDocuments") }}</h3>
          <div slot="body">
            <p>{{ $t("profile.edit.documentInfo") }}</p>
            <p class="alert alert-danger" v-if="errors.kyc">{{ errors.kyc }}</p>
            <div class="documents__list">
              <div v-for="(file, index) in documents" :key="index" class="col-xs-4 col-md-3">
                <div class="documents__item">
                  <embed v-if="file.base64.includes('data:application/pdf')"  :src="file.base64" width="100%"/>
                  <img v-else :src="file.base64" alt="" style="width: 100%">
                  <span class="remove-documents" @click="removeDocument(documents, index)">×</span>
                </div>
                <p>{{ file.name }}</p>
              </div>
            </div>
            <upload-base64 :multiple='false' :done='addFiles' ref='file_input' class='btn btn-default'></upload-base64>
            <button type='button' :disabled="processing" @click='$refs.file_input.$refs.input.click();' class="btn btn-default button-wide-crowd">
              {{ $t('profile.kyc.addDocuments') }}
            </button>
          </div>
          <button type="submit" :disabled="processing" slot="footer" class="btn btn-primary" style="width: 100px; margin: 5px">
            <span v-if="!processing">{{ $t("send") }}</span>
            <clip-loader :loading="processing" :color="'#fff'" size="17px"></clip-loader>
          </button>
        </modal>
      </form>
    </transition>
  </div>
</template>

<script>
import userApi from '@/api/v1/user';
import Modal from '@/components/Modal';
import KycStatus from '@/components/KYC/Status';
import UploadBase64 from '@/components/UploadBase64';
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
  props: {
    documentId: {
      type: String,
      default: '',
    },
  },
  components: { Modal, UploadBase64, ClipLoader, KycStatus },
  data() {
    return {
      kycDocument: {
        Id: this.documentId,
      },
      modalOpen: false,
      documents: [],
      processing: false,
      errors: {
        kyc: '',
      },
    };
  },
  computed: {
    documentsSubmitted() {
      return this.kycDocument.Id && this.kycDocument.Status !== 'REFUSED';
    },
  },
  methods: {
    close() {
      this.modalOpen = false;
    },
    open() {
      this.modalOpen = true;
    },
    addFiles(file) {
      this.documents.push({ name: file.name, base64: file.base64 });
    },
    removeDocument(from, index) {
      from.splice(index, 1);
    },
    sendDocuments() {
      this.processing = true;
      const binaryDocuments = this.documents.map(document => document.base64.replace(/data:\w+\/\w+;base64,/, ''));
      userApi.createUserKycDocument(binaryDocuments)
        .then(() => {
          this.submitDocuments();
        }).catch((e) => {
          this.errors.kyc = e.response.data.error.Message;
          this.processing = false;
        });
    },
    submitDocuments() {
      userApi.submitUserKycDocument()
        .then((response) => {
          this.processing = false;
          this.kycDocument = response.data;
          this.$emit('submitted', response.data);
          this.close();
        }).catch((e) => {
          this.errors.kyc = e.response.data.error.Message;
          this.processing = false;
        });
    },
    checkDocumentsStatus() {
      this.processing = true;
      userApi.checkUserKycDocument()
        .then((response) => {
          this.processing = false;
          this.kycDocument = response.data;
        }).catch(() => {
          this.processing = false;
        });
    },
  },
  created() {
    this.checkDocumentsStatus();
  },
};
</script>



// WEBPACK FOOTER //
// Kyc.vue?d26d27e0